module.exports = __webpack_public_path__ + "img/logo_2.c1554bd9.png";